import {
  languageBuilder
} from "./builder.js";
const anime_airing = {
  UNIT_SINGULAR: `\u0421\u0435\u0440\u0438\u0430\u043B`,
  UNIT_PLURAL: `\u0421\u0435\u0440\u0438\u0430\u043B\u044B`,
  UNIT_SHORT: `\u0421\u0435\u0440\u0438\u0430\u043B`,
  SUBUNIT_SINGULAR: `\u0441\u0435\u0440\u0438\u044E`,
  SUBUNIT_PLURAL: `\u0441\u0435\u0440\u0438\u0438`,
  SUBUNIT_SHORT: `\u0441\u0435\u0440.`,
  SUBUNIT_VERB_FUTURE: `\u0412\u044B\u0445\u043E\u0434\u0438\u0442`,
  SUBUNIT_VERB_PAST: `\u0412\u044B\u0448\u043B\u0430`
};
const anime_bluray = {
  UNIT_SINGULAR: `\u0421\u0435\u0440\u0438\u0430\u043B`,
  UNIT_PLURAL: `\u0421\u0435\u0440\u0438\u0430\u043B\u044B`,
  UNIT_SHORT: `\u0421\u0435\u0440\u0438\u0430\u043B`,
  SUBUNIT_SINGULAR: `\u0422\u043E\u043C`,
  SUBUNIT_PLURAL: `\u0422\u043E\u043C\u0430`,
  SUBUNIT_SHORT: `\u0422\u043E\u043C`,
  SUBUNIT_VERB_FUTURE: `\u0412\u044B\u0445\u043E\u0434\u0438\u0442`,
  SUBUNIT_VERB_PAST: `\u0412\u044B\u0448\u0435\u043B`
};
const manga_chapter = {
  UNIT_SINGULAR: `\u041C\u0430\u043D\u0433\u0430`,
  UNIT_PLURAL: `\u041C\u0430\u043D\u0433\u0438`,
  UNIT_SHORT: `\u041C\u0430\u043D\u0433\u0430`,
  SUBUNIT_SINGULAR: `\u0433\u043B\u0430\u0432\u0430`,
  SUBUNIT_PLURAL: `\u0433\u043B\u0430\u0432\u044B`,
  SUBUNIT_SHORT: `\u0433\u043B.`,
  SUBUNIT_VERB_FUTURE: `\u0412\u044B\u0445\u043E\u0434\u0438\u0442`,
  SUBUNIT_VERB_PAST: `\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u0430`
};
const manga_volume = {
  UNIT_SINGULAR: `\u041C\u0430\u043D\u0433\u0430`,
  UNIT_PLURAL: `\u041C\u0430\u043D\u0433\u0438`,
  UNIT_SHORT: `\u041C\u0430\u043D\u0433\u0430`,
  SUBUNIT_SINGULAR: `\u0422\u043E\u043C`,
  SUBUNIT_PLURAL: `\u0422\u043E\u043C\u0430`,
  SUBUNIT_SHORT: `\u0422\u043E\u043C`,
  SUBUNIT_VERB_FUTURE: `\u0412\u044B\u0445\u043E\u0434\u0438\u0442`,
  SUBUNIT_VERB_PAST: `\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D`
};
const strings = {
  ALL_COMPLETE: `\u0412\u0441\u0435 \u043F\u0440\u043E\u0435\u043A\u0442\u044B \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B!`,
  CONNECTION_ERROR: `\u0421\u0431\u043E\u0439 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F`,
  CONFIG_HEADER: `\u041A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u044F`,
  WEBSITE_SETTINGS_HEADER: `\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0441\u0430\u0439\u0442\u0430`,
  APP_URL: `\u0410\u0434\u0440\u0435\u0441 \u0432\u0430\u0448\u0435\u0433\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F`,
  LINK_PAGE: `\u041F\u0435\u0440\u0435\u0439\u0442\u0438 \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443`,
  PAGE_BGCOLOR: `\u0426\u0432\u0435\u0442 \u0444\u043E\u043D\u0430 \u0433\u043B\u0430\u0432\u043D\u043E\u0433\u043E \u0441\u0430\u0439\u0442\u0430`,
  NO_COLOR: `\u0418\u0433\u043D\u043E\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0446\u0432\u0435\u0442 \u0444\u043E\u043D\u0430`,
  RECOMMENDED_BGCOLOR: `\u0420\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u0446\u0432\u0435\u0442 \u0444\u043E\u043D\u0430`,
  OVERRIDE_BGCOLOR: `\u0417\u0430\u043C\u0435\u043D\u0438\u0442\u044C \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u044E`,
  THEME_HEADER: `\u0412\u044B\u0431\u043E\u0440 \u0442\u0435\u043C\u044B`,
  THEME_LIGHT: `\u0421\u0432\u0435\u0442\u043B\u0430\u044F`,
  THEME_DARK: `\u0422\u0435\u043C\u043D\u0430\u044F`,
  SIZE_HEADER: `\u0412\u044B\u0431\u043E\u0440 \u0440\u0430\u0437\u043C\u0435\u0440\u0430`,
  SIZE_SMALL: `\u041C\u0430\u043B\u0435\u043D\u044C\u043A\u0438\u0439 (\u041D\u0435 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u0442\u0441\u044F)`,
  SIZE_NORMAL: `\u041D\u043E\u0440\u043C\u0430\u043B\u044C\u043D\u044B\u0439`,
  ACCENT_HEADER: `\u0426\u0432\u0435\u0442 \u0448\u0430\u043F\u043A\u0438`,
  ACCENT_RED: `\u041A\u0440\u0430\u0441\u043D\u044B\u0439`,
  ACCENT_YELLOW: `\u0416\u0451\u043B\u0442\u044B\u0439`,
  ACCENT_GREEN: `\u0417\u0435\u043B\u0451\u043D\u044B\u0439`,
  ACCENT_BLUE: `\u0421\u0438\u043D\u0438\u0439`,
  ACCENT_INDIGO: `\u0418\u043D\u0434\u0438\u0433\u043E`,
  ACCENT_PURPLE: `\u0424\u0438\u043E\u043B\u0435\u0442\u043E\u0432\u044B\u0439`,
  ACCENT_PINK: `\u0420\u043E\u0437\u043E\u0432\u044B\u0439`,
  ACCENT_NONE: `\u0411\u0435\u0437 \u0446\u0432\u0435\u0442\u0430`,
  LANGUAGE_HEADER: `\u042F\u0437\u044B\u043A`,
  EMBED_HEADER: `\u041A\u043E\u0434 \u0434\u043B\u044F Wordpress`,
  EMBED_DESCRIPTION: `\u0418\u0437\u043C\u0435\u043D\u0438\u0442\u044C \u0440\u0430\u0437\u043C\u0435\u0440 iframe \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u044B`,
  EMBED_SHOW: `\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0432\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0435\u043C\u044B\u0439 \u043A\u043E\u0434`,
  EMBED_HIDE: `\u0421\u043A\u0440\u044B\u0442\u044C \u0432\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0435\u043C\u044B\u0439 \u043A\u043E\u0434`,
  ALL_POSITIONS: `\u0412\u0441\u0435 \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u0438`,
  UNIT_JOINT_WITH: `\u0421\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u043E \u0441 {0}`,
  UNIT_SHOW_LESS: `\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043C\u0435\u043D\u044C\u0448\u0435`,
  UNIT_SHOW_LESS_PLURAL: void 0,
  UNIT_SHOW_REMAINDER_SINGULAR: `\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0435\u0449\u0451 {1} %SUBUNIT_SINGULAR%...`,
  UNIT_SHOW_REMAINDER_PLURAL: `\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u0435\u0449\u0451 {1} %SUBUNIT_PLURAL%...`,
  UNIT_UPDATED: `\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u043E {2}`,
  SUBUNIT_NOT_PUBLISHED: `%SUBUNIT_SHORT% {0} %SUBUNIT_VERB_FUTURE% {1}`,
  SUBUNIT_WAS_PUBLISHED: `%SUBUNIT_SHORT% {0} %SUBUNIT_VERB_PAST% {1}`,
  SUBUNIT_TO_RELEASE: `%SUBUNIT_SHORT% {0} \u0431\u0443\u0434\u0435\u0442 \u0432\u044B\u043F\u0443\u0449\u0435\u043D\u0430`,
  SUBUNIT_IN_PROGRESS: `%SUBUNIT_SHORT% {0} \u0442\u0440\u0435\u0431\u0443\u0435\u0442 {2}`,
  SUBUNIT_NO_PROGRESS: `(\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0430 \u043D\u0435\u0442)`
};
import ru from "../../_snowpack/pkg/javascript-time-ago/locale/ru.json.proxy.js";
const lang = {
  locale: ru,
  strings
};
export default {
  anime_airing: languageBuilder(lang, anime_airing),
  anime_bluray: languageBuilder(lang, anime_bluray),
  manga_chapter: languageBuilder(lang, manga_chapter),
  manga_volume: languageBuilder(lang, manga_volume)
};
//# sourceMappingURL=ru.js.map
